import {useState} from "react";

import {useTailwindViewport} from "@fleet/common/hooks/useTailwindViewport";

import {GhostButton, Tooltip} from "@bolteu/kalep-react";
import {Placement} from "@bolteu/kalep-react/build/components/Tooltip/Tooltip.types";

interface ClickableToolTipProps {
    children: React.ReactNode;
    placement: Placement;
    content: string;
}

export function ClickableToolTip({placement, children, content}: ClickableToolTipProps) {
    const [isOpen, setIsOpen] = useState(false);
    const size = useTailwindViewport();
    const isMobile = size === "sm" || size === "md";

    const handleClick = () => {
        setIsOpen(!isOpen);

        setTimeout(() => {
            setIsOpen(false);
        }, 2000); // Close the tooltip after 2 seconds
    };

    const isOpenValue = isMobile ? isOpen : undefined;

    return (
        <Tooltip content={content} placement={placement} isOpen={isOpenValue}>
            <GhostButton onClick={handleClick}>{children}</GhostButton>
        </Tooltip>
    );
}
